module.exports = __webpack_public_path__ + "fd87244.ttf";